'use strict';

require('../../modules/forms/forms');
require('../../helpers/show-modal-message/show-modal-message');

angular.module('far.modals.mountain-route-images', [
  'angularFileUpload',
  'dekky.forms',
  'far.helpers.showModalMessage'
])
.controller('MountainRouteImagesController', function(
  $uibModalInstance,
  FileUploader,
  fileUploadFilters,
  mountainRoute,
  showModalMessage,
  isAdmin
) {
  var vm = {
    isAdmin: isAdmin,
    slidesFiles: new FileUploader({
      url: Routing.generate('api_upload_post_image'),
      autoUpload: true,
      filters: [fileUploadFilters.fileType('png', 'jpg', 'jpeg'), fileUploadFilters.fileSize()],
      onWhenAddingFileFailed: function(item, filter) {
        var message = filter.message ? filter.message : 'Невозможно загрузить файл на сервер';
        showModalMessage(message);
      },
      onErrorItem: function(item) {
        showModalMessage('Невозможно загрузить файл на сервер');
        item.remove();
      },
      onSuccessItem: function(item, response) {
        item.serverData = response;
      }
    }),
    close: function() {
			$uibModalInstance.dismiss();
		},
    submitChanges: function() {
      mountainRoute.slides_files = vm.slidesFiles.queue.map(function(slide, index) {
          slide.serverData.sort = index + 1;
          return slide.serverData;
      });

      mountainRoute.save()
          .then(function () {
              $uibModalInstance.close();
          })
          .catch(function(response) {
              $uibModalInstance.dismiss({error: 'Возникла проблема при сохранении изменений. Попробуйте позже.'});
          });
    }
  };

  mountainRoute.slides_files.forEach(function(serverFile) {
    var newFile = new FileUploader.FileItem(vm.slidesFiles, {
      lastModifiedDate: new Date(),
      size: 1e6,
      image_name: serverFile.original_name
    });

    newFile.progress = 100;
    newFile.isUploaded = true;
    newFile.isSuccess = true;
    newFile.serverData = angular.merge({}, serverFile);

    vm.slidesFiles.queue.push(newFile);
  });

  return vm;
});
